var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFtfTelegramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_803_1060)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5 0.676514C10.7878 0.676514 7.22437 2.15242 4.60156 4.77698C1.97606 7.4026 0.500751 10.9634 0.5 14.6765C0.5 18.388 1.97656 21.9515 4.60156 24.576C7.22437 27.2006 10.7878 28.6765 14.5 28.6765C18.2122 28.6765 21.7756 27.2006 24.3984 24.576C27.0234 21.9515 28.5 18.388 28.5 14.6765C28.5 10.965 27.0234 7.40155 24.3984 4.77698C21.7756 2.15242 18.2122 0.676514 14.5 0.676514Z",
    fill: "url(#paint0_linear_803_1060)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.83723 14.5287C10.9191 12.7507 13.6404 11.5785 15.001 11.0121C18.8904 9.39484 19.6975 9.11397 20.2247 9.10445C20.3407 9.10259 20.5988 9.13125 20.7672 9.26742C20.9072 9.38227 20.9466 9.53758 20.9663 9.64663C20.9838 9.75556 21.0079 10.0038 20.9882 10.1977C20.7782 12.4114 19.866 17.7835 19.4022 20.263C19.2075 21.3121 18.8204 21.6639 18.4463 21.6982C17.6325 21.773 17.0157 21.161 16.2282 20.6449C14.9966 19.8371 14.301 19.3344 13.1044 18.5463C11.7219 17.6354 12.6188 17.1347 13.4063 16.3165C13.6119 16.1024 17.195 12.8441 17.2629 12.5486C17.2716 12.5116 17.2804 12.3738 17.1972 12.3012C17.1163 12.2283 16.996 12.2533 16.9085 12.2729C16.7838 12.3009 14.8172 13.6021 11.0022 16.1761C10.4444 16.5598 9.93911 16.7468 9.48411 16.737C8.98536 16.7262 8.02286 16.4543 7.30755 16.222C6.43255 15.937 5.73473 15.7863 5.79598 15.3022C5.82661 15.0502 6.17442 14.7923 6.83723 14.5287Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_803_1060",
    x1: 1400.5,
    y1: 0.676514,
    x2: 1400.5,
    y2: 2800.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_803_1060"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0.5 0.676514)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFtfTelegramIcon);
export default __webpack_public_path__ + "static/media/ftf_telegram_icon.912edb26361ffbba050e4343dd3877ac.svg";
export { ForwardRef as ReactComponent };